angular.module('picmonicng').directive('resourceTile', [
  function () {
    return {
      restrict: 'E',
      scope: {
        resource: '<',
      },
      replace: true,
      templateUrl: '/templates/directives/resource-tile.html',
      controller: [
        '$rootScope',
        '$scope',
        'UserService',
        function ($rootScope, $scope, UserService) {
          $scope.base_asset_url = $rootScope.base_asset_url;
          $scope.UserService = UserService;
        },
      ],
    };
  },
]);
